import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Button, ButtonGroup } from "react-bootstrap";

import {
  loadPatientsList,
  openWhatsAppChat,
  hideWhatsAppChat,
  archiveWhChatting,
  initPatientsList,
} from "../../actions/whatsAppChattingActions";
import { Routes } from "../../constants/Routes";
import Header from "../layout/DefaultPageHeader";
import PatientsWhatsappFilterForm from "./WhatsAppForm";
import { createUrl, parseQuery } from "../../utils/UrlUtils";
import WhatsAppChattingUsersTable from "./WhatsAppChattingPatientsList";
import { resetPatientWhatsappMessages } from "../../actions/patientWhMessagesActions";

const enhancer = connect(({ whatsappChatting, dashboard, auth, calendar: { clinicId } }) => {
  return { whatsappChatting, dashboard, auth, clinicId };
});
const WhatsAppChatting = (props) => {
  const queryParams = parseQuery(props.location.search);
  const isArchived = props.history.location.search.includes("archived=true");
  const [selectedTab, setSelectedTab] = useState("unread");

  useEffect(() => {
    // props.dispatch(loadPatientsList({ archived: isArchived, ...queryParams }));
  }, [props.location.search]);

  useEffect(() => {
    const query = parseQuery(props.location.search);

    props.dispatch(
      initPatientsList({
        chartNumber: new URLSearchParams(props.location.search).get("chartNumber"),
        archived: isArchived,
        readStatusId: selectedTab === "unread" ? 0 : null,
        clinicId: query.clinicId != null ? query.clinicId : props.clinicId,
        startTime: query.startTime,
        endTime: query.endTime,
      }),
    );
  }, [isArchived, selectedTab, props.location.search]);

  const archiveWHChatting = (patientKey) => {
    props.dispatch(archiveWhChatting(patientKey));
  };

  const tabChange = (bool, readStatusId) => {
    props.history.push(
      createUrl(Routes.DashboardWhatsappChatting, {
        query: {
          ...queryParams,
          archived: bool,
          readStatusId,
        },
      }),
    );
  };

  const openChattingSidebar = (patient) => {
    props.history.push(
      createUrl(Routes.DashboardWhatsappChatting, {
        query: {
          ...parseQuery(props.location.search),
          pKey: patient.patientKey,
        },
      }),
    );
    props.dispatch(openWhatsAppChat(patient));
  };

  const hideChattingSidebar = () => {
    props.history.push(
      createUrl(Routes.DashboardWhatsappChatting, {
        query: {
          ...parseQuery(props.location.search),
          pKey: null,
        },
      }),
    );

    props.dispatch(resetPatientWhatsappMessages());
    props.dispatch(hideWhatsAppChat());
  };

  const loadPatientsListFunc = () => {
    props.dispatch(loadPatientsList({ clinicId: props.clinicId }));
  };

  const { whatsappChattingActions } = props;

  const { whatsappChatting } = props;

  return (
    <div className="whatsapp-chatting-page">
      <Header
        addClass="whatsapp-chatting-header mt-1"
        onClick={() => props.history.push(Routes.DashboardCalendar)}
      >
        <PatientsWhatsappFilterForm
          onSubmit={() => props.dispatch(whatsappChattingActions.getPatientsListWhChats())}
        />
      </Header>
      <div className="whatsapp-chatting-users">
        <ButtonGroup className="whatsapp-chatting-tab-buttons">
          <Button
            bssize="lg"
            style={{ width: "100%" }}
            variant={selectedTab === "unread" ? "primary" : "light"}
            onClick={() => {
              setSelectedTab("unread");
              tabChange(false, 1);
            }}
          >
            Unread
          </Button>
          <Button
            bssize="lg"
            style={{ width: "100%" }}
            variant={selectedTab === "read" ? "primary" : "light"}
            onClick={() => {
              setSelectedTab("read");
              tabChange(false, 0);
            }}
          >
            Read
          </Button>
          <Button
            bssize="lg"
            style={{ width: "100%" }}
            onClick={() => {
              setSelectedTab("archive");
              tabChange(true, 0);
            }}
            variant={selectedTab === "archive" ? "primary" : "light"}
          >
            Archived
          </Button>
        </ButtonGroup>
        <WhatsAppChattingUsersTable
          history={props.history}
          location={props.location}
          loadPatientsList={loadPatientsListFunc}
          hideWhatsAppChat={hideChattingSidebar}
          openWhatsAppChat={openChattingSidebar}
          archivePatientChatting={archiveWHChatting}
          setChattingPatientList={whatsappChattingActions?.setChattingPatientsList || []}
          list={whatsappChatting.list || []}
          chatSidebarVisible={whatsappChatting.chatSidebarVisible}
        />
      </div>
    </div>
  );
};

export default withRouter(enhancer(WhatsAppChatting));
